import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Features.css";

import securityImage from "../assets/236.webp";
import durabilityImage from "../assets/460.webp";
import energyEfficiencyImage from "../assets/506.webp";

const Features = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="features" id="features">
      <h2 data-aos="fade-up">Features of GÜÇH DOORS</h2>
      <div className="features-grid">
        <div className="feature-item" data-aos="zoom-in-up">
          <img
            src={securityImage}
            alt="Enhanced Security"
            className="feature-image"
          />
          <h3>Enhanced Security</h3>
          <p>
            Our doors are equipped with multi-point locking systems,
            tamper-proof hinges, and reinforced steel frames for maximum
            security.
          </p>
        </div>

        <div className="feature-item" data-aos="zoom-in-up">
          <img
            src={durabilityImage}
            alt="Extreme Durability"
            className="feature-image"
          />
          <h3>Extreme Durability</h3>
          <p>
            GUCH doors are built to withstand the harshest weather conditions
            with rust-resistant coatings and high-quality materials.
          </p>
        </div>

        <div className="feature-item" data-aos="zoom-in-up">
          <img
            src={energyEfficiencyImage}
            alt="Energy Efficiency"
            className="feature-image"
          />
          <h3>Energy Efficiency</h3>
          <p>
            Designed to provide superior thermal insulation, our doors help keep
            your home comfortable and reduce energy consumption.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
